// Two consecutive line terminators end a frame, and each may independently be CRLF, CR or
// LF. Ordered longest-first so a lone CRLF is never read as two terminators.
const FRAME_SEPARATOR = /\r\n\r\n|\r\n\r|\r\n\n|\r\r\n|\r\r|\n\r\n|\n\r|\n\n/;
const LINE_SEPARATOR = /\r\n|\n|\r/;

export type SseEvent = {
    event: string;
    data: string;
};

/** Accumulates decoded text and emits whole SSE frames as separators arrive. */
export function createSseFrameBuffer() {
    let buffer = '';

    return {
        // An unterminated trailing record is intentionally never emitted: the SSE grammar
        // dispatches on a blank line, so a truncated stream must not produce an event.
        push(chunk: string): string[] {
            buffer += chunk;

            const frames = buffer.split(FRAME_SEPARATOR);

            buffer = frames.pop() ?? '';

            return frames.filter((frame) => frame.trim());
        },
    };
}

export function parseSseEvent(frame: string): SseEvent | null {
    let event = '';
    const dataLines: string[] = [];

    frame.split(LINE_SEPARATOR).forEach((line) => {
        if (line.startsWith(':')) {
            return;
        }

        if (line.startsWith('event:')) {
            event = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
            // The SSE grammar strips one optional leading space, not all whitespace.
            dataLines.push(line.slice(5).replace(/^ /, ''));
        }
    });

    if (!dataLines.length) {
        return null;
    }

    return { event, data: dataLines.join('\n') };
}
